export type InstallationConfig = {
  customerTypes: CustomerTypeConfig[];
  insuranceTypes: InsuranceTypeConfig[];
  marketSpecificFields: MarketSpecificFields[];
  registrationDefaultValues: defaultvalues[];
  openUpForEditMaxDays: number;
  showUnregisteredDevicesFromDeliveryDate: ShowUnregisteredDevicesFromDeliveryDateConfig[];
} | null;

export type MarketSpecificFields = {
  field: string;
  validForSalesMarkets: string[];
};

export enum MarketSpecificFieldType {
  PropertyType = 'PropertyType',
}

export type OnsiteConfig = {
  // featureFlags: FeatureFlag[];
  // partner: Partner;
  // token: UserTokenInformation;
  installation: InstallationConfig;
};

export type CustomerTypeConfig = {
  displayName: string;
  code: string;
  type: string;
  validForSalesMarkets: string[];
};

export type InsuranceTypeConfig = {
  displayName: string;
  code: string;
  isMega: boolean;
  validCustomerTypes: string[];
  validCustomerCodes: string[];
  validForSalesMarkets: string[];
};

export type defaultvalues = {
  salesMarket: string;
  phoneCountryCode: string;
  customerType: string;
  insuranceType: string;
  customerCode: string;
};

export type ShowUnregisteredDevicesFromDeliveryDateConfig = {
  market: string;
  date: Date;
};
